// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".org-select-container .ui-collapse__heading{height:30px;font-size:13px}.current-section{font-weight:700!important;color:#13161c!important}.current-section p{margin:0;padding:0}", ""]);
// Exports
module.exports = exports;
